function collectSelectedAddonItemsForProductForm(formId) {
  if (!formId) {
    return [];
  }
  return Array.from(document.querySelectorAll(`yq-product-addons[data-product-form-id="${formId}"] [data-addon-card]`)).filter((card) => {
    return card.querySelector(".yq-product-addons__toggle.is-selected");
  }).map((card) => {
    return {
      id: card.getAttribute("data-selected-variant-id") || card.getAttribute("data-default-variant-id"),
      quantity: 1
    };
  }).filter((item) => !!item.id);
}
function yqFormatMoney(cents) {
  const settings = window.themeVariables?.settings || {};
  const format = (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || "${{amount}}";
  const abs = Math.max(0, Math.round(Number(cents) || 0));
  const value = (abs / 100).toFixed(2);
  const [whole, fraction = "00"] = value.split(".");
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const noDecimals = Math.round(abs / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return format.replace(/\{\{\s*amount\s*\}\}/g, `${withCommas}.${fraction}`).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${fraction}`).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals.replace(/,/g, ".")).replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${fraction}`);
}
function yqFormatSaveBadge(savingsCents) {
  const template = window.themeVariables?.strings?.discountBadgeHtml || "Save %%SAVINGS%%";
  const settings = window.themeVariables?.settings || {};
  let format = (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || "${{amount}}";
  format = format.replaceAll("amount_no_decimals_with_comma_separator", "amount_with_comma_separator").replaceAll("amount_no_decimals", "amount");
  const abs = Math.max(0, Math.round(Number(savingsCents) || 0));
  const value = (abs / 100).toFixed(2);
  const [whole, fraction = "00"] = value.split(".");
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formatted = format.replace(/\{\{\s*amount\s*\}\}/g, `${withCommas}.${fraction}`).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${fraction}`).replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${fraction}`);
  return template.replace("%%SAVINGS%%", formatted);
}
function yqSetPriceNodeText(node, formatted) {
  if (!node) {
    return;
  }
  const srOnly = node.querySelector(":scope > .sr-only");
  node.textContent = "";
  if (srOnly) {
    node.appendChild(srOnly);
  }
  node.append(` ${formatted}`);
}
function yqSyncAddonBuyTotals(formId) {
  if (!formId) {
    return;
  }
  const form = document.getElementById(formId) || document.forms[formId];
  const qty = Math.max(1, parseInt(form?.querySelector('[name="quantity"]')?.value, 10) || 1);
  let addonPrice = 0;
  let addonCompare = 0;
  let addonSave = 0;
  document.querySelectorAll(`yq-product-addons[data-product-form-id="${formId}"] [data-addon-card]`).forEach((card) => {
    if (!card.querySelector(".yq-product-addons__toggle.is-selected")) {
      return;
    }
    const selectedSwatch = card.querySelector("[data-addon-swatch].is-selected");
    const price = parseInt(selectedSwatch?.dataset.variantPriceCents || card.getAttribute("data-price"), 10) || 0;
    const compare = parseInt(selectedSwatch?.dataset.variantCompareCents || card.getAttribute("data-compare-price"), 10) || 0;
    addonPrice += price;
    if (compare > price) {
      addonCompare += compare;
      addonSave += compare - price;
    }
  });
  document.querySelectorAll(`[data-yq-buy-totals][data-product-form-id="${formId}"]`).forEach((root) => {
    let basePrice = parseInt(root.getAttribute("data-base-price"), 10);
    if (!Number.isFinite(basePrice)) {
      const donor = Array.from(document.querySelectorAll(`[data-yq-buy-totals][data-product-form-id="${formId}"]`)).map((el) => parseInt(el.getAttribute("data-base-price"), 10)).find((value) => Number.isFinite(value));
      if (!Number.isFinite(donor)) {
        return;
      }
      basePrice = donor;
      root.setAttribute("data-base-price", String(donor));
    }
    const parsedCompare = parseInt(root.getAttribute("data-base-compare"), 10);
    const baseCompare = Number.isFinite(parsedCompare) ? parsedCompare : basePrice;
    const mainPrice = basePrice * qty;
    const hasMainCompare = baseCompare > basePrice;
    const mainCompare = (hasMainCompare ? baseCompare : 0) * qty;
    const mainSave = hasMainCompare ? Math.max(0, baseCompare - basePrice) * qty : 0;
    let totalPrice = mainPrice + addonPrice;
    let totalCompare = mainCompare + addonCompare;
    let savings = mainSave + addonSave;
    if (typeof window.yqCouponAdjustBuyTotals === "function") {
      const adjusted = window.yqCouponAdjustBuyTotals({ totalPrice, totalCompare, savings });
      if (adjusted) {
        totalPrice = adjusted.totalPrice;
        totalCompare = adjusted.totalCompare;
        savings = adjusted.savings;
      }
    }
    const showCompare = savings > 0 && totalCompare > 0;
    const salePrice = root.querySelector("sale-price");
    let compareAt = root.querySelector("compare-at-price");
    yqSetPriceNodeText(salePrice, yqFormatMoney(totalPrice));
    if (salePrice) {
      salePrice.classList.toggle("text-on-sale", showCompare);
    }
    if (showCompare) {
      if (!compareAt && salePrice) {
        compareAt = document.createElement("compare-at-price");
        compareAt.className = "text-subdued line-through";
        compareAt.innerHTML = `<span class="sr-only"></span>`;
        salePrice.after(compareAt);
      }
      if (compareAt) {
        yqSetPriceNodeText(compareAt, yqFormatMoney(totalCompare));
        compareAt.hidden = false;
        compareAt.classList.remove("is-hidden");
        compareAt.style.display = "";
      }
    } else if (compareAt) {
      compareAt.hidden = true;
      compareAt.classList.add("is-hidden");
      compareAt.style.display = "none";
    }
    if (typeof window.yqCouponUpdateFloatingDesktopPrice === "function") {
      window.yqCouponUpdateFloatingDesktopPrice(root, totalPrice, totalCompare, savings);
    } else {
      const desktopCurrent = root.querySelector(".yq-pdp-floating-bar__price-current");
      let desktopCompare = root.querySelector(".yq-pdp-floating-bar__price-compare");
      if (desktopCurrent) {
        desktopCurrent.textContent = yqFormatMoney(totalPrice);
      }
      if (showCompare) {
        if (!desktopCompare && desktopCurrent) {
          desktopCompare = document.createElement("span");
          desktopCompare.className = "yq-pdp-floating-bar__price-compare";
          desktopCurrent.after(desktopCompare);
        }
        if (desktopCompare) {
          desktopCompare.textContent = yqFormatMoney(totalCompare);
          desktopCompare.hidden = false;
          desktopCompare.style.display = "";
        }
      } else if (desktopCompare) {
        desktopCompare.hidden = true;
        desktopCompare.style.display = "none";
      }
    }
    let badgeList = root.querySelector(".yq-inline-buy-row__badge-list, .yq-pdp-floating-bar__mobile-badges, .product-info__badge-list");
    let badge = root.querySelector(".badge--on-sale");
    if (savings > 0) {
      if (!badgeList && salePrice) {
        badgeList = document.createElement("div");
        badgeList.className = root.matches(".yq-pdp-floating-bar") ? "yq-pdp-floating-bar__mobile-badges product-info__badge-list" : "yq-inline-buy-row__badge-list product-info__badge-list";
        salePrice.parentElement?.append(badgeList);
      }
      if (!badge && badgeList) {
        badge = document.createElement("on-sale-badge");
        badge.className = "badge badge--on-sale";
        badgeList.append(badge);
      }
      if (badge) {
        badge.textContent = yqFormatSaveBadge(savings);
        badge.hidden = false;
        badge.classList.remove("is-hidden");
        badge.style.removeProperty("display");
      }
    } else {
      root.querySelectorAll(".badge--on-sale").forEach((node) => {
        node.hidden = true;
        node.classList.add("is-hidden");
        node.style.display = "none";
      });
    }
  });
}
window.yqSyncAddonBuyTotals = yqSyncAddonBuyTotals;
window.yqFormatMoney = yqFormatMoney;
window.yqFormatSaveBadge = yqFormatSaveBadge;
window.yqSetPriceNodeText = yqSetPriceNodeText;
if (!window.__yqAddonTotalsBound) {
  window.__yqAddonTotalsBound = true;
  document.addEventListener("product:rerender", () => {
    window.setTimeout(() => {
      document.querySelectorAll("yq-product-addons[data-product-form-id]").forEach((root) => {
        yqSyncAddonBuyTotals(root.getAttribute("data-product-form-id"));
      });
    }, 0);
  });
  document.addEventListener("change", (event) => {
    const quantityInput = event.target?.closest?.(".quantity-selector__input, [name='quantity']");
    if (!quantityInput) {
      return;
    }
    const form = quantityInput.form || quantityInput.closest("form") || document.getElementById(quantityInput.getAttribute("form"));
    if (form?.id) {
      yqSyncAddonBuyTotals(form.id);
    }
  });
}
// js/sections/yq-product-addons.js
function yqRestoreAddonModal(modal) {
  if (!modal) {
    return;
  }
  modal.hidden = true;
  if (modal.__yqOriginalParent) {
    if (modal.__yqNextSibling && modal.__yqNextSibling.parentNode === modal.__yqOriginalParent) {
      modal.__yqOriginalParent.insertBefore(modal, modal.__yqNextSibling);
    } else {
      modal.__yqOriginalParent.appendChild(modal);
    }
  }
  if (modal.__yqOpener) {
    modal.__yqOpener.setAttribute("aria-expanded", "false");
  } else {
    const opener = document.querySelector(`.yq-product-addons__more[aria-controls="${modal.id}"]`);
    opener?.setAttribute("aria-expanded", "false");
  }
  document.documentElement.classList.remove("lock");
}
window.yqOpenAddonModal = function(modalId, opener) {
  const modal = document.getElementById(modalId);
  if (!modal) {
    return false;
  }
  if (!modal.__yqOriginalParent) {
    modal.__yqOriginalParent = modal.parentNode;
    modal.__yqNextSibling = modal.nextSibling;
  }
  document.body.appendChild(modal);
  modal.hidden = false;
  modal.__yqOpener = opener || null;
  if (opener) {
    opener.setAttribute("aria-expanded", "true");
  }
  document.documentElement.classList.add("lock");
  return false;
};
window.yqCloseAddonModal = function(modalId) {
  const modal = typeof modalId === "string" ? document.getElementById(modalId) : modalId;
  yqRestoreAddonModal(modal);
  return false;
};
document.documentElement.classList.remove("lock");
var YqProductAddons = class extends HTMLElement {
  connectedCallback() {
    this._onClick = this._handleClick.bind(this);
    this._onPointerDown = this._handlePointerDown.bind(this);
    this._onPointerUp = this._handlePointerUp.bind(this);
    this._onTouchStart = this._handleTouchStart.bind(this);
    this._onTouchEnd = this._handleTouchEnd.bind(this);
    this._onScroll = this._handleScroll.bind(this);
    this._onResize = this._syncPager.bind(this);
    this._onDocumentClick = this._handleDocumentClick.bind(this);
    this._touchActivation = null;
    this._touchFallbackActivation = null;
    this._lastDirectTouchHandledAt = 0;
    this._carousel = this.querySelector(".yq-product-addons__carousel");
    const navButtons = this.querySelectorAll(".yq-product-addons__nav-button");
    this._prevButton = navButtons[0] || null;
    this._nextButton = navButtons[1] || null;
    this.addEventListener("click", this._onClick);
    this.addEventListener("pointerdown", this._onPointerDown, true);
    this.addEventListener("pointerup", this._onPointerUp, true);
    this.addEventListener("touchstart", this._onTouchStart, { capture: true, passive: true });
    this.addEventListener("touchend", this._onTouchEnd, { capture: true, passive: false });
    document.addEventListener("click", this._onDocumentClick);
    this._carousel?.addEventListener("scroll", this._onScroll, { passive: true });
    window.addEventListener("resize", this._onResize);
    this.querySelectorAll("[data-addon-card]").forEach((card) => {
      const toggle = card.querySelector(".yq-product-addons__toggle");
      const isSelected = toggle?.classList.contains("is-selected");
      card.classList.toggle("is-unselected", !isSelected);
      if (toggle) {
        toggle.setAttribute("aria-pressed", isSelected ? "true" : "false");
      }
      if (!card.getAttribute("data-selected-variant-id")) {
        card.setAttribute("data-selected-variant-id", card.getAttribute("data-default-variant-id") || "");
      }
      const selectedSwatch = card.querySelector("[data-addon-swatch].is-selected");
      if (selectedSwatch) {
        this._applySwatch(card, selectedSwatch);
      }
    });
    this._syncPager();
    yqSyncAddonBuyTotals(this.getAttribute("data-product-form-id"));
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    this.removeEventListener("pointerdown", this._onPointerDown, true);
    this.removeEventListener("pointerup", this._onPointerUp, true);
    this.removeEventListener("touchstart", this._onTouchStart, true);
    this.removeEventListener("touchend", this._onTouchEnd, true);
    document.removeEventListener("click", this._onDocumentClick);
    this._carousel?.removeEventListener("scroll", this._onScroll);
    window.removeEventListener("resize", this._onResize);
  }
  _handlePointerDown(event) {
    if (event.pointerType !== "touch") {
      return;
    }
    const interactiveTarget = this._getInteractiveAddonTarget(event.target) || this._getInteractiveAddonTargetAtPoint(event.clientX, event.clientY);
    if (!interactiveTarget) {
      this._touchActivation = null;
      return;
    }
    this._touchActivation = {
      target: interactiveTarget,
      x: event.clientX,
      y: event.clientY
    };
    event.stopPropagation();
  }
  _handlePointerUp(event) {
    if (event.pointerType !== "touch") {
      return;
    }
    if (Date.now() - this._lastDirectTouchHandledAt < 500) {
      return;
    }
    const interactiveTarget = this._getInteractiveAddonTarget(event.target) || this._getInteractiveAddonTargetAtPoint(event.clientX, event.clientY);
    const touchActivation = this._touchActivation;
    this._touchActivation = null;
    if (!interactiveTarget || !touchActivation || interactiveTarget !== touchActivation.target) {
      return;
    }
    if (Math.abs(event.clientX - touchActivation.x) > 8 || Math.abs(event.clientY - touchActivation.y) > 8) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this._ignoreNextClickTarget = interactiveTarget;
    window.setTimeout(() => {
      if (this._ignoreNextClickTarget === interactiveTarget) {
        this._ignoreNextClickTarget = null;
      }
    }, 400);
    this._lastDirectTouchHandledAt = Date.now();
    this._activateAddonControl(interactiveTarget);
  }
  _handleTouchStart(event) {
    if (event.touches.length !== 1) {
      return;
    }
    const touch = event.touches[0];
    const interactiveTarget = this._getInteractiveAddonTarget(event.target) || this._getInteractiveAddonTargetAtPoint(touch.clientX, touch.clientY);
    if (!interactiveTarget) {
      this._touchFallbackActivation = null;
      return;
    }
    this._touchFallbackActivation = {
      target: interactiveTarget,
      x: touch.clientX,
      y: touch.clientY
    };
    event.stopPropagation();
  }
  _handleTouchEnd(event) {
    if (Date.now() - this._lastDirectTouchHandledAt < 500) {
      return;
    }
    const touch = event.changedTouches[0];
    const touchActivation = this._touchFallbackActivation;
    this._touchFallbackActivation = null;
    if (!touch || !touchActivation) {
      return;
    }
    const interactiveTarget = this._getInteractiveAddonTarget(event.target) || this._getInteractiveAddonTargetAtPoint(touch.clientX, touch.clientY);
    if (!interactiveTarget || interactiveTarget !== touchActivation.target) {
      return;
    }
    if (Math.abs(touch.clientX - touchActivation.x) > 8 || Math.abs(touch.clientY - touchActivation.y) > 8) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this._ignoreNextClickTarget = interactiveTarget;
    window.setTimeout(() => {
      if (this._ignoreNextClickTarget === interactiveTarget) {
        this._ignoreNextClickTarget = null;
      }
    }, 400);
    this._lastDirectTouchHandledAt = Date.now();
    this._activateAddonControl(interactiveTarget);
  }
  _handleClick(event) {
    const interactiveTarget = this._getInteractiveAddonTarget(event.target);
    if (interactiveTarget && this._ignoreNextClickTarget === interactiveTarget) {
      event.preventDefault();
      event.stopPropagation();
      this._ignoreNextClickTarget = null;
      return;
    }
    if (this._prevButton && event.target.closest(".yq-product-addons__nav-button") === this._prevButton) {
      event.preventDefault();
      event.stopPropagation();
      this._pageBy(-1);
      return;
    }
    if (this._nextButton && event.target.closest(".yq-product-addons__nav-button") === this._nextButton) {
      event.preventDefault();
      event.stopPropagation();
      this._pageBy(1);
      return;
    }
    const toggle = event.target.closest("[data-addon-card] .yq-product-addons__toggle");
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggle.classList.remove("is-selected");
      toggle.setAttribute("aria-pressed", "false");
      this._openAddonModalFromCard(toggle);
      return;
    }
    const swatch = event.target.closest("[data-addon-swatch]");
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest("[data-addon-card]");
      if (!card) {
        return;
      }
      this._applySwatch(card, swatch);
      const linkedModalId = swatch.dataset.modalId;
      if (linkedModalId) {
        const modal = document.getElementById(linkedModalId);
        const modalSwatch = modal?.querySelector(`[data-addon-modal-swatch][data-variant-id="${swatch.dataset.variantId}"]`);
        if (modal && modalSwatch) {
          this._applyModalSwatch(modal, modalSwatch);
        }
      }
      return;
    }
  }
  _getInteractiveAddonTarget(target) {
    if (!target?.closest) {
      return null;
    }
    return target.closest("[data-addon-card] .yq-product-addons__toggle, [data-addon-card] .yq-product-addons__more, [data-addon-swatch]");
  }
  _getInteractiveAddonTargetAtPoint(clientX, clientY) {
    const target = document.elementFromPoint(clientX, clientY);
    if (!target || !this.contains(target)) {
      return null;
    }
    return this._getInteractiveAddonTarget(target);
  }
  _activateAddonControl(target) {
    if (target.matches(".yq-product-addons__toggle")) {
      target.classList.remove("is-selected");
      target.setAttribute("aria-pressed", "false");
      this._openAddonModalFromCard(target);
      return;
    }
    if (target.matches(".yq-product-addons__more")) {
      if (window.yqOpenAddonQuickBuy) {
        window.yqOpenAddonQuickBuy(target);
      }
      return;
    }
    if (target.matches("[data-addon-swatch]")) {
      const card = target.closest("[data-addon-card]");
      if (!card) {
        return;
      }
      this._applySwatch(card, target);
      const linkedModalId = target.dataset.modalId;
      if (linkedModalId) {
        const modal = document.getElementById(linkedModalId);
        const modalSwatch = modal?.querySelector(`[data-addon-modal-swatch][data-variant-id="${target.dataset.variantId}"]`);
        if (modal && modalSwatch) {
          this._applyModalSwatch(modal, modalSwatch);
        }
      }
    }
  }
  _openAddonModalFromCard(toggle) {
    if (window.yqOpenAddonQuickBuy) {
      window.yqOpenAddonQuickBuy(toggle);
      return true;
    }
    return this._openAddonQuickBuy(toggle);
  }
  _openAddonQuickBuy(toggle) {
    const drawer = this._getAddonQuickBuy(toggle);
    if (window.yqOpenAddonQuickBuy) {
      window.yqOpenAddonQuickBuy(toggle);
      return true;
    }
    if (drawer && typeof drawer.show === "function") {
      drawer.show();
      return true;
    }
    return false;
  }
  _closeAddonQuickBuy(toggle) {
    const drawer = this._getAddonQuickBuy(toggle);
    if (drawer?.open && typeof drawer.hide === "function") {
      drawer.hide();
    }
  }
  _getAddonQuickBuy(toggle) {
    const card = toggle?.closest("[data-addon-card]");
    const drawerId = card?.getAttribute("data-quick-buy-id") || toggle?.getAttribute("aria-controls");
    return drawerId ? document.getElementById(drawerId) : null;
  }
  _toggleAddonCard(toggle) {
    const card = toggle.closest("[data-addon-card]");
    const selected = toggle.classList.toggle("is-selected");
    toggle.setAttribute("aria-pressed", selected ? "true" : "false");
    card?.classList.toggle("is-unselected", !selected);
    yqSyncAddonBuyTotals(this.getAttribute("data-product-form-id"));
  }
  _handleDocumentClick(event) {
    const modalPrev = event.target.closest("[data-addon-modal-prev]");
    if (modalPrev) {
      event.preventDefault();
      const modal = modalPrev.closest(".yq-addon-modal");
      this._stepModalMedia(modal, -1);
      return;
    }
    const modalNext = event.target.closest("[data-addon-modal-next]");
    if (modalNext) {
      event.preventDefault();
      const modal = modalNext.closest(".yq-addon-modal");
      this._stepModalMedia(modal, 1);
      return;
    }
    const modalDot = event.target.closest("[data-addon-modal-dot]");
    if (modalDot) {
      event.preventDefault();
      const modal = modalDot.closest(".yq-addon-modal");
      this._setModalMediaIndex(modal, parseInt(modalDot.dataset.index || "0", 10));
      return;
    }
    const modalOverlay = event.target.closest(".yq-addon-modal__overlay");
    if (modalOverlay) {
      event.preventDefault();
      event.stopPropagation();
      const modal = modalOverlay.closest(".yq-addon-modal");
      this._closeModal(modal);
      return;
    }
    const modalClose = event.target.closest(".yq-addon-modal__close");
    if (modalClose) {
      event.preventDefault();
      event.stopPropagation();
      const modal = modalClose.closest(".yq-addon-modal");
      this._closeModal(modal);
      return;
    }
    const modalSwatch = event.target.closest("[data-addon-modal-swatch]");
    if (modalSwatch) {
      const modal = modalSwatch.closest(".yq-addon-modal");
      if (!modal) {
        return;
      }
      this._applyModalSwatch(modal, modalSwatch);
      const linkedCard = this.querySelector(`[data-addon-card][data-modal-id="${modal.id}"]`);
      if (linkedCard) {
        const cardSwatch = linkedCard.querySelector(`[data-addon-swatch][data-variant-id="${modalSwatch.dataset.variantId}"]`);
        if (cardSwatch) {
          this._applySwatch(linkedCard, cardSwatch);
        }
      }
      return;
    }
    const modalAddButton = event.target.closest("[data-addon-modal-add]");
    if (modalAddButton) {
      event.preventDefault();
      const modal = modalAddButton.closest(".yq-addon-modal");
      this._addModalVariantToCart(modal, modalAddButton);
    }
  }
  _applySwatch(card, swatch) {
    card.querySelectorAll("[data-addon-swatch]").forEach((item) => {
      const active = item === swatch;
      item.classList.toggle("is-selected", active);
      item.setAttribute("aria-pressed", active ? "true" : "false");
    });
    const image = card.querySelector(".yq-product-addons__image");
    const price = card.querySelector("[data-addon-price]");
    const comparePrice = card.querySelector("[data-addon-compare-price]");
    const discount = card.querySelector("[data-addon-discount]");
    if (swatch.dataset.variantImage && image) {
      image.setAttribute("src", swatch.dataset.variantImage);
      image.setAttribute("srcset", `${swatch.dataset.variantImage} 316w`);
    }
    if (swatch.dataset.variantPrice && price) {
      price.textContent = swatch.dataset.variantPrice;
    }
    if (comparePrice) {
      comparePrice.textContent = swatch.dataset.variantComparePrice || "";
      comparePrice.classList.toggle("is-hidden", !swatch.dataset.variantComparePrice);
    }
    if (discount) {
      const discountPercent = swatch.dataset.variantDiscountPercent;
      discount.textContent = discountPercent ? `-${discountPercent}%` : "";
      discount.classList.toggle("is-hidden", !discountPercent);
    }
    if (swatch.dataset.variantId) {
      card.setAttribute("data-selected-variant-id", swatch.dataset.variantId);
    }
    const priceCents = parseInt(swatch.dataset.variantPriceCents, 10);
    const compareCents = parseInt(swatch.dataset.variantCompareCents, 10);
    if (Number.isFinite(priceCents)) {
      card.setAttribute("data-price", String(priceCents));
      card.setAttribute("data-compare-price", String(Number.isFinite(compareCents) ? compareCents : priceCents));
    }
    const save = card.querySelector("[data-addon-save]");
    if (save) {
      const savings = Math.max(0, (Number.isFinite(compareCents) ? compareCents : priceCents) - (Number.isFinite(priceCents) ? priceCents : 0));
      const saveLabel = card.closest("yq-product-addons")?.dataset.saveText || "Save";
      save.textContent = savings > 0 ? `${saveLabel} ${yqFormatMoney(savings)}` : "";
      save.classList.toggle("is-hidden", savings <= 0);
    }
    yqSyncAddonBuyTotals(this.getAttribute("data-product-form-id"));
  }
  _applyModalSwatch(modal, swatch) {
    modal.querySelectorAll("[data-addon-modal-swatch]").forEach((item) => {
      const active = item === swatch;
      item.classList.toggle("is-selected", active);
      item.setAttribute("aria-pressed", active ? "true" : "false");
    });
    const title = modal.querySelector("[data-addon-modal-title]");
    if (swatch.dataset.variantTitle && title) {
      title.textContent = swatch.dataset.variantTitle;
    }
    const mediaId = swatch.dataset.variantMediaId;
    if (mediaId) {
      const slides = Array.from(modal.querySelectorAll("[data-addon-modal-slide]"));
      const matchedIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (matchedIndex >= 0) {
        this._setModalMediaIndex(modal, matchedIndex);
      }
    }
    modal.querySelector("[data-addon-modal-root]")?.setAttribute("data-selected-variant-id", swatch.dataset.variantId || "");
  }
  async _addModalVariantToCart(modal, button) {
    const modalRoot = modal?.querySelector("[data-addon-modal-root]");
    const variantId = modalRoot?.getAttribute("data-selected-variant-id") || modalRoot?.getAttribute("data-default-variant-id");
    if (!variantId || !button) {
      return;
    }
    button.setAttribute("aria-busy", "true");
    const loader = button.querySelector(".yq-addon-modal__cta-loader");
    if (loader) {
      loader.hidden = false;
    }
    try {
      const sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const payload = new FormData();
      payload.append("id", variantId);
      payload.append("quantity", "1");
      payload.append("sections", sectionsToBundle.join(","));
      payload.append("sections_url", `${Shopify.routes.root}variants/${variantId}`);
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: payload,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        return;
      }
      if (typeof window.yqCouponAfterAddToCart === "function") {
        try {
          await window.yqCouponAfterAddToCart();
        } catch (e) {
        }
      }
      this._closeModal(modal);
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    } finally {
      button.removeAttribute("aria-busy");
      if (loader) {
        loader.hidden = true;
      }
    }
  }
  _closeModalById(modalId) {
    const modal = document.getElementById(modalId);
    this._closeModal(modal);
  }
  _closeModal(modal) {
    yqRestoreAddonModal(modal);
  }
  _pageBy(direction) {
    if (!this._carousel) {
      return;
    }
    const maxScrollLeft = Math.max(0, this._carousel.scrollWidth - this._carousel.clientWidth);
    const pageWidth = this._carousel.clientWidth;
    const current = this._carousel.scrollLeft;
    const target = direction > 0 ? Math.min(maxScrollLeft, current + pageWidth) : Math.max(0, current - pageWidth);
    this._carousel.scrollTo({ left: target, behavior: "smooth" });
  }
  _stepModalMedia(modal, direction) {
    if (!modal) {
      return;
    }
    const slides = Array.from(modal.querySelectorAll("[data-addon-modal-slide]"));
    if (slides.length <= 1) {
      return;
    }
    const currentIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
    const nextIndex = (currentIndex + direction + slides.length) % slides.length;
    this._setModalMediaIndex(modal, nextIndex);
  }
  _setModalMediaIndex(modal, index) {
    if (!modal) {
      return;
    }
    const slides = Array.from(modal.querySelectorAll("[data-addon-modal-slide]"));
    const dots = Array.from(modal.querySelectorAll("[data-addon-modal-dot]"));
    if (slides.length === 0) {
      return;
    }
    const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle("is-active", slideIndex === safeIndex);
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle("is-active", dotIndex === safeIndex);
    });
  }
  _handleScroll() {
    this._syncPager();
  }
  _syncPager() {
    if (!this._carousel) {
      return;
    }
    const maxScrollLeft = Math.max(0, this._carousel.scrollWidth - this._carousel.clientWidth);
    const current = this._carousel.scrollLeft;
    const atStart = current <= 2;
    const atEnd = current >= maxScrollLeft - 2;
    if (this._prevButton) {
      this._prevButton.disabled = atStart;
    }
    if (this._nextButton) {
      this._nextButton.disabled = atEnd;
    }
  }
};
if (!window.customElements.get("yq-product-addons")) {
  window.customElements.define("yq-product-addons", YqProductAddons);
}

var YqAddonQuickBuyDrawer = class extends HTMLElement {
  connectedCallback() {
    this._hasLoaded = false;
  }
  _ensureShell() {
    if (this._shell) {
      return;
    }
    const shell = document.createElement("div");
    shell.className = "yq-addon-quick-buy";
    shell.hidden = true;
    shell.innerHTML = '<div class="yq-addon-quick-buy__overlay"></div><div class="yq-addon-quick-buy__panel" role="dialog" aria-modal="true"><button type="button" class="yq-addon-quick-buy__close" aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button><div data-quick-buy-body></div></div>';
    shell.querySelector(".yq-addon-quick-buy__overlay").addEventListener("click", () => this.hide());
    shell.querySelector(".yq-addon-quick-buy__close").addEventListener("click", () => this.hide());
    shell.addEventListener("variant:add", () => this.hide());
    this._onKeydown = (event) => {
      if (event.key === "Escape") {
        this.hide();
      }
    };
    this._shell = shell;
  }
  async show() {
    if (window.yqOpenAddonQuickBuy) {
      window.yqOpenAddonQuickBuy(this);
      return;
    }
    this._ensureShell();
    if (this._hasLoaded || this._loading) {
      if (this._hasLoaded) {
        this._shell._yqOpenSeq = (this._shell._yqOpenSeq || 0) + 1;
        const seq = this._shell._yqOpenSeq;
        document.body.appendChild(this._shell);
        this._shell.hidden = false;
        this._shell.classList.remove("is-open");
        document.documentElement.style.overflow = "hidden";
        requestAnimationFrame(() => {
          if (this._shell._yqOpenSeq !== seq) return;
          this._shell.classList.add("is-open");
        });
      }
      return;
    }
    this._loading = true;
    const body = this._shell.querySelector("[data-quick-buy-body]");
    body.textContent = "";
    try {
      const root = window.Shopify?.routes?.root || "/";
      const handle = this.getAttribute("handle") || "";
      const response = await fetch(`${root}products/${handle}`);
      const html = await response.text();
      const template = new DOMParser().parseFromString(html, "text/html").getElementById("yq-addon-quick-buy-content");
      if (template?.content) {
        body.append(template.content.cloneNode(true));
        this._hasLoaded = true;
        this._shell._yqOpenSeq = (this._shell._yqOpenSeq || 0) + 1;
        const seq = this._shell._yqOpenSeq;
        document.body.appendChild(this._shell);
        this._shell.hidden = false;
        this._shell.classList.remove("is-open");
        document.documentElement.style.overflow = "hidden";
        requestAnimationFrame(() => {
          if (this._shell._yqOpenSeq !== seq) return;
          this._shell.classList.add("is-open");
        });
      }
    } finally {
      this._loading = false;
    }
  }
  hide() {
    if (!this._shell) {
      return;
    }
    const shell = this._shell;
    document.removeEventListener("keydown", this._onKeydown);
    if (shell.hidden || !shell.classList.contains("is-open")) return;
    const seq = shell._yqOpenSeq;
    shell.classList.remove("is-open");
    let finished = false;
    const finish = () => {
      if (finished || shell._yqOpenSeq !== seq) return;
      finished = true;
      shell.hidden = true;
      document.documentElement.style.overflow = "";
    };
    const panel = shell.querySelector(".yq-addon-quick-buy__panel");
    if (panel) {
      panel.addEventListener("transitionend", (event) => {
        if (event.target === panel && event.propertyName === "transform") finish();
      }, { once: true });
    }
    window.setTimeout(finish, 420);
  }
};
if (!window.customElements.get("quick-buy-drawer")) {
  window.customElements.define("quick-buy-drawer", YqAddonQuickBuyDrawer);
}

document.addEventListener('variant:add', async (event) => {
  const form = event.target;
  const formId = form && form.id;
  if (!formId || typeof collectSelectedAddonItemsForProductForm !== 'function') return;
  const items = collectSelectedAddonItemsForProductForm(formId);
  if (!items.length) return;
  try {
    await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items })
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  } catch (error) {}
});
